export default {

    apiKey: localStorage.getItem('api_key'),
    user: null, // User object
    alerts: [], // Global alerts
    loading: false, // Global loader
    refreshing: false, // Refreshing API key
    showModal: false, // Toggle a modal
    params: {}, // Page-level params
    inviteToken: null, // Invite token
    redirect: null, // Redirect route name (after sign-in)

}